const locale = {
  placeholder: 'ÐÐ·Ð±Ð¾Ñ Ð½Ð° ÑÐ°Ñ',
};

export default locale;
